import Dialog from "@mui/material/Dialog"
import React, { PropsWithChildren } from "react"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"

import { useDashboardConfig } from "@features/results/Result/Dashboard/dashboardConfig"

export const DashboardFullScreenDialog = (props: PropsWithChildren) => {
  const [cfg, updateCfg] = useDashboardConfig()

  if (!cfg.isFullscreen) return <></>

  const handleClose = () => {
    updateCfg((draft) => {
      draft.isFullscreen = false
    })
  }

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      fullScreen
      sx={{ display: cfg.isFullscreen ? "inline-block" : "none" }}
    >
      <div style={{ position: "absolute", top: 5, right: 5 }}>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <div style={{ padding: 10, height: "100%" }}>{props.children}</div>
    </Dialog>
  )
}
